import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useWorkspaceMembers } from '../hooks/useWorkspaceMembers';
import { addWorkspaceMember, removeWorkspaceMember, updateMemberRole } from '../utils/workspaceMemberUtils';
import AddMemberForm from './workspace/AddMemberForm';
import MembersList from './workspace/MembersList';
import {
    ModalBody,
    ErrorMessage,
} from '../styles/ManageWorkspaceMembers.styles';
import {
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalTitle,
    CloseButton,
} from '../styles/CreateWorkspaceModal.styles';

const ManageWorkspaceMembersModal = ({ workspace, onClose }) => {
    const [email, setEmail] = useState('');
    const [error, setError] = useState('');
    const { user } = useAuth();
    const { members, loading } = useWorkspaceMembers(workspace.members);

    const handleAddMember = async (e) => {
        e.preventDefault();
        setError('');

        try {
            await addWorkspaceMember(workspace, email, user.uid);
            setEmail('');
        } catch (error) {
            setError(error.message);
        }
    };

    const handleRemoveMember = async (memberId) => {
        if (memberId === user.uid) {
            setError("You can't remove yourself");
            return;
        }

        try {
            await removeWorkspaceMember(workspace, memberId);
        } catch (error) {
            setError('Failed to remove member');
        }
    };

    const handleRoleChange = async (memberId, newRole) => {
        if (memberId === user.uid) {
            setError("You can't change your own role");
            return;
        }

        try {
            await updateMemberRole(workspace, memberId, newRole);
        } catch (error) {
            setError('Failed to update role');
        }
    };

    const handleOverlayClick = (e) => {
        if (e.target === e.currentTarget) {
            onClose();
        }
    };

    return (
        <ModalOverlay onClick={handleOverlayClick}>
            <ModalContent onClick={e => e.stopPropagation()}>
                <ModalHeader>
                    <ModalTitle>Manage Workspace Members</ModalTitle>
                    <CloseButton onClick={onClose}>&times;</CloseButton>
                </ModalHeader>
                <ModalBody>
                    <AddMemberForm
                        email={email}
                        onEmailChange={setEmail}
                        onSubmit={handleAddMember}
                    />

                    {error && <ErrorMessage>{error}</ErrorMessage>}

                    {!loading && (
                        <MembersList
                            members={members}
                            currentUserId={user.uid}
                            onRoleChange={handleRoleChange}
                            onRemoveMember={handleRemoveMember}
                        />
                    )}
                </ModalBody>
            </ModalContent>
        </ModalOverlay>
    );
};

export default ManageWorkspaceMembersModal;